import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { GroupAdminEmailParams, sendGroupAdminWelcomeEmail } from '@utils/backend-api/group-admins';

const useGroupAdminWelcomeEmail = () => {
  return useMutation((params: GroupAdminEmailParams) => sendGroupAdminWelcomeEmail(params), {
    onSuccess: () => {
      toast.success('Email invitation resent successfully');
    },
    onError: () => {
      toast.error('Failed to resend email invitation');
    },
  });
};

export default useGroupAdminWelcomeEmail;
